<div
  *ngIf="showPasswordInit"
  class="bg-lightest h-full flex place-content-center">
  <div class="px-4 lg:w-1/2 mt-4 md:mt-10">
    <h1 class="flex flex-row md:justify-center text-3xl md:text-5xl mb-5 md:mb-10 font-app-bold md:mt-2">
      {{ "loginPage.title" | translate }}
    </h1>
    <app-password-form
      [isInitPassword]="false"
      (passwordSubmit)="onPasswordSubmit($event)"></app-password-form>

    <div
      class="bg-white flex flex-row rounded-lg shadow-none p-3 mt-10 md:mb-10 border border-t-light border-r-light border-b-light border-l-8 border-solid border-primary_text">
      <div>
        <i class="pi pi-info-circle mr-2 text-primary_text font-bold"></i>
      </div>
      <div>
        <p class="font-app-bold text-sm md:text-base">
          {{ "passwordMessages.createPassword" | translate }}
        </p>
        <app-popup-password-template></app-popup-password-template>
      </div>
    </div>
  </div>

  <app-link-expiration-dialog
    [visibleDialog]="isDialogVisible"
    (onClose)="handleDialogClose()">
  </app-link-expiration-dialog>
</div>
